var _defs, _clipPath, _path, _defs2, _clipPath2, _path2, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M43 17.9H22.5v8.5h11.8c-1.1 5.4-5.7 8.5-11.8 8.5-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9L37 5.5C33.1 2.1 28.1 0 22.4 0 10.3-.1.4 9.7.4 22s9.8 22 22 22c11 0 21-8 21-22 .1-1.3 0-2.7-.4-4.1z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    overflow: "visible"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1.5 35V9l17 13-17 13z",
    clipPath: "url(#b)",
    fill: "#fbbc05"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M43 17.9H22.5v8.5h11.8c-1.1 5.4-5.7 8.5-11.8 8.5-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9L37 5.5C33.1 2.1 28.1 0 22.4 0 10.3-.1.4 9.7.4 22s9.8 22 22 22c11 0 21-8 21-22 .1-1.3 0-2.7-.4-4.1z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    overflow: "visible"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.5 9l17 13 7-6.1 24-3.9V-2h-48V9z",
    clipPath: "url(#d)",
    fill: "#ea4335"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M43 17.9H22.5v8.5h11.8c-1.1 5.4-5.7 8.5-11.8 8.5-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9L37 5.5C33.1 2.1 28.1 0 22.4 0 10.3-.1.4 9.7.4 22s9.8 22 22 22c11 0 21-8 21-22 .1-1.3 0-2.7-.4-4.1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-1.5 35l30.1-23 7.9 1 10-15.1v48h-48V35z",
    clipPath: "url(#f)",
    fill: "#34a853"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M43 17.9H22.5v8.5h11.8c-1.1 5.4-5.7 8.5-11.8 8.5-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9L37 5.5C33.1 2.1 28.1 0 22.4 0 10.3-.1.4 9.7.4 22s9.8 22 22 22c11 0 21-8 21-22 .1-1.3 0-2.7-.4-4.1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.5 46l-31-24-4-3 35-10v37z",
    clipPath: "url(#h)",
    fill: "#4285f4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.621b694912d9d6b89479794cd196c809.svg";
export { ForwardRef as ReactComponent };